import type { StoryCtx } from '@dispositio/core';
import type { StoryPayload } from '@dispositio/shared';
import { createContext, useContext } from 'react';
import type { StoryActions } from '../api/hooks';

/** Die geladene Geschichte samt Index und Aktionen, für alle Bausteine des Arbeitsbereichs. */
export interface StoryEnv {
  projectId: string;
  story: StoryPayload;
  ctx: StoryCtx;
  actions: StoryActions;
  /**
   * Zu einem Node navigieren: den umgebenden Node öffnen und ihn auswählen; mit `docId` das Textdokument im Texteditor öffnen (mit
   * `review` gleich zum Prüfen der möglichen Verweise);
   * Einträge ohne Platz auf einer Fläche werden in der Bibliothek ausgewählt.
   */
  goTo: (target: { nodeId: string | null; entityId?: string | null; docId?: string | null; review?: boolean }) => void;
}

export const StoryEnvContext = createContext<StoryEnv | null>(null);

export function useStoryEnv(): StoryEnv {
  const env = useContext(StoryEnvContext);
  if (!env) throw new Error('StoryEnvContext fehlt');
  return env;
}
